/** 이용안내 탭 정보 */
export const GUIDE_TAB = [
  { value: "basicInfo", label: "기본정보" },
  { value: "product", label: "연결정보(상품)" },
  { value: "contract", label: "연결정보(신청/계약)" },
];

/** 이용안내 상세 탭 정보 (변경내역 탭은 상세에서만 노출) */
export const GUIDE_DETAIL_TAB = [...GUIDE_TAB, { value: "history", label: "변경내역" }];
